import { render, staticRenderFns } from "./ManagerNewBookingRequest.vue?vue&type=template&id=6f9a8b24&"
import script from "./ManagerNewBookingRequest.vue?vue&type=script&lang=js&"
export * from "./ManagerNewBookingRequest.vue?vue&type=script&lang=js&"
import style0 from "./ManagerNewBookingRequest.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports